(function(){
  var toc=document.querySelector('.jfnb-toc');
  if(toc){
    var links=[].slice.call(toc.querySelectorAll('a[href^="#jfnb-h"]'));
    var now=toc.querySelector('.jfnb-toc__now');
    var map={};links.forEach(function(a){map[a.getAttribute('href').slice(1)]=a;});
    var heads=Object.keys(map).map(function(id){return document.getElementById(id);}).filter(Boolean);
    if('IntersectionObserver' in window && heads.length){
      var cur=null;
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){if(e.isIntersecting){cur=e.target.id;}});
        if(!cur)return;
        links.forEach(function(a){a.classList.remove('is-active');a.removeAttribute('aria-current');});
        var a=map[cur];if(a){a.classList.add('is-active');a.setAttribute('aria-current','true');if(now)now.textContent=a.textContent;}
      },{rootMargin:'-110px 0px -65% 0px',threshold:0});
      heads.forEach(function(h){io.observe(h);});
    }
    if(window.matchMedia&&window.matchMedia('(max-width:1099px)').matches){toc.removeAttribute('open');}
  }
  var cp=document.querySelector('.jfnb-share__copy');
  if(cp){cp.addEventListener('click',function(){
    var u=cp.getAttribute('data-url'),t=cp.textContent;
    function ok(){cp.textContent='Kopiert';setTimeout(function(){cp.textContent=t;},1800);}
    if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(u).then(ok,function(){});}
  });}
})();
